import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import { getMeetingItemByUuid } from 'Shared/selectors/common';

import './NotificationBar.scss';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

type Props = {
  parentUuid: string;
  itemUuid: string;
};

enum NotificatinType {
  newItem = 'new_item',
  newComment = 'new_comment',
}

function NotificationBar({ itemUuid, parentUuid }: Props) {
  const { tr } = useTranslation();
  const notification = useSelector((state: any) => {
    const { modifiedItemsUuids, modifiedCommentsUuids } = state.workspace.workspaceNotifications || {};
    const item = getMeetingItemByUuid(itemUuid)(state);

    // If notifications is not exist
    if (!modifiedCommentsUuids?.length && !modifiedItemsUuids?.length) return null;
    // If notification is exist and notification for parent item exist
    if (modifiedItemsUuids?.includes(itemUuid) && modifiedItemsUuids?.includes(parentUuid)) return null;
    // If notification is exist and notification for parent item not exist
    if (modifiedItemsUuids.includes(itemUuid)) return NotificatinType.newItem;
    // If notification for item is not exist but exist for his comment
    if (item?.comments?.some(({ uuid }) => modifiedCommentsUuids?.includes(uuid))) return NotificatinType.newComment;

    // If notification is not exist for item and his comments
    return null;
  });

  if (notification === NotificatinType.newItem)
    return <div className="workspace-item-container-notification-bar">{tr('perform.workspace.notifications.new')}</div>;

  if (notification === NotificatinType.newComment)
    return (
      <div className="workspace-item-container-notification-bar">
        {tr('perform.workspace.notifications.new_comment')}
      </div>
    );

  return null;
}

export default memo(NotificationBar);
